import React from 'react';

import { InsightsContainer } from './styled';

export const Insights = () => {
  return <InsightsContainer>Insights content placeholder</InsightsContainer>;
};
